// extracted by mini-css-extract-plugin
export var backdropBlur = "_ms-0";